import React from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import { /*Input, */NumericTextBox } from '@progress/kendo-react-inputs';
import { isEmpty, queryStringBuilder/*, convertDatestampToObject, getLocaleDateString*/ } from "../helpers";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from '@progress/kendo-react-buttons';
import "@progress/kendo-theme-material/dist/all.css";
import isPage from "../hoc/isPage";
//import { AppContext } from '../context/AppContext';
import FormSection from '../components/FormSection';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import DatePickerContainer from '../components/DatePickerContainer';

class EditPartExceptionPage extends React.Component {
    static propTypes = {
        orgID: PropTypes.number,
        orgVendorID: PropTypes.string,
        partNumber: PropTypes.string,
        seasons: PropTypes.array,
        adjustmentReasons: PropTypes.array,
        //partException: PropTypes.object,
        handleCloseModal: PropTypes.func,
        handleRefreshListing: PropTypes.func
    }

    state = {
        orgVendorID: '',
        partNumber: '',
        vendorCode: '',
        neverOrder: false,
        noReturn: false,
        stockingMIN: null,
        stockingMAX: null,
        minExpiryDate: null,
        maxExpiryDate: null,
        season: null,
        seasonMin: null,
        adjReason: null,

        seasons: [],
        adjustmentReasons: [],

        showConfirmationDialog: false
    }

    componentDidMount() {

        //this.props.getData('/api/portal/adjustmentReason/GetList').then((adjustmentReasons) => {
        //    this.setState({
        //        adjustmentReasons: [{ adjustmentReasonID: null, adjustmentReason: "" }].concat(adjustmentReasons.data),
        //    })
        //})

        let builder = new queryStringBuilder();
        builder.append("orgID", this.props.orgID);
        builder.append("orgVendorID", this.props.orgVendorID);
        builder.append("partNumber", this.props.partNumber);
        builder.append("exception", -1);
        builder.append("exactMatch", true);
        builder.append("uiLanguage", this.props.uiLanguage)

        // filter the data
        this.props
            .getData(
                `/api/portal/part/GetPartExceptions${builder.queryString}`
            )
            .then(response => {
                //console.log(response.data)
                const partException = response.data[0];

                if (partException) {
                    let minExpiryDate = partException.minExpiryDate;
                    let maxExpiryDate = partException.maxExpiryDate;

                    if (minExpiryDate) {
                        minExpiryDate = moment(minExpiryDate, "YYYYMMDD").toDate();
                    }
                    if (maxExpiryDate) {
                        maxExpiryDate = moment(maxExpiryDate, "YYYYMMDD").toDate();
                    }
                    this.setState({
                        adjustmentReasons: this.props.adjustmentReasons,
                        seasons: this.props.seasons,

                        orgVendorID: this.props.orgVendorID,
                        partNumber: this.props.partNumber,
                        vendorCode: partException.vendorCode,
                        neverOrder: partException.neverOrder,
                        noReturn: partException.noReturn,
                        stockingMIN: partException.stockingMIN,
                        stockingMAX: partException.stockingMAX,
                        minExpiryDate: minExpiryDate,
                        maxExpiryDate: maxExpiryDate,
                        season: partException.season,
                        seasonMin: partException.seasonMin,
                        adjReason: partException.adjReason,
                    });
                }
            })
            .catch(error => {
                this.props.alert(
                    "error",
                    this.props.returnLocalizedString("m0023"),
                    this.props.returnLocalizedString("m0134", "", this.props.partNumber)
                );
            });
    }

    handleCloseConfirmationDialog = (e, props) => {

        this.setState({
            showConfirmationDialog: false
        });
    }

    handleSubmit = (e, skipConfirmation) => {
        // do a post to /api/portal/part/UpdatePartExceptions

        let apiUrl = '/api/portal/part/UpdatePartExceptions';

        // "set" or "deleted"
        let action = '';

        // validation
        // required fields: org name, org type, country, state, language, currency 
        const { orgVendorID, partNumber, neverOrder, noReturn, stockingMIN, stockingMAX, season, seasonMin, adjReason } = this.state;

        let errorMessage = '';
        if (neverOrder && (isEmpty(adjReason) || adjReason.adjustmentReasonID <= 0)) {
            errorMessage = this.props.returnLocalizedString("m0135");
        }
        else {
            if (stockingMIN !== null && stockingMAX !== null) {
                if (stockingMIN > stockingMAX) {
                    errorMessage = this.props.returnLocalizedString("m0136");
                }
            }
            if ((seasonMin > 0) && (isEmpty(season) || season.seasonID <= 0)) {
                errorMessage = this.props.returnLocalizedString("m0137");
            }
        }

        if (!isEmpty(errorMessage)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }

        if (!skipConfirmation) {
            if (neverOrder && (stockingMIN !== null || stockingMAX !== null || (!isEmpty(season) && season.seasonID > 0) || seasonMin > 0)) {
                // bring up the dialog
                this.setState({
                    showConfirmationDialog: true
                });
                return;
            }
        }

        const minExpiryDate = (this.state.minExpiryDate) ? moment(this.state.minExpiryDate).format("YYYYMMDD") : null;
        const maxExpiryDate = (this.state.maxExpiryDate) ? moment(this.state.maxExpiryDate).format("YYYYMMDD") : null;

        const payload = [{
            orgID: this.props.orgID,
            orgVendorID: orgVendorID,
            partNumber: partNumber,
            neverOrder: neverOrder,
            noReturn: noReturn,
            stockingMIN: stockingMIN,
            stockingMAX: stockingMAX,
            minExpiryDate: minExpiryDate,
            maxExpiryDate: maxExpiryDate,
            seasonID: isEmpty(season) ? null : season.seasonID,
            seasonMin: seasonMin,
            adjustmentReasonID: isEmpty(adjReason) ? null : adjReason.adjustmentReasonID
        }]
        //console.log(noReturn)
        if (neverOrder || stockingMIN || stockingMAX || noReturn || (season === null ? null : season.seasonID)) { // set exception
            action = "m0138"
        } else { // deleted exception
            action = "m0139"
        }
        //console.log('submitting this info', JSON.stringify(payload));

        //let hasError = false;
        this.props.postData(apiUrl, payload).then(response => {
            //console.log(response)
            this.props.alert("success", this.props.returnLocalizedString("m0036"), this.props.returnLocalizedString("m0140", action ));

            //this.props.handleRefreshListing();
            this.props.handleCloseModal(this, payload);

        }).catch(error => {
            //hasError = true;
            //console.log('set/delete exception error: ', error.message)
            
            this.props.alert("error", this.props.returnLocalizedString("m0141", action), `${error.response.data}`);
        });

        //if (!hasError)
        //    this.props.handleCloseModal(this, payload);
    }

    handleClearData = () => {
        this.setState({
            neverOrder: false,
            noReturn: false,
            stockingMIN: null,
            stockingMAX: null,
            minExpiryDate: null,
            maxExpiryDate: null,
            season: null,
            seasonMin: null,
            adjReason: null
        });
    }

    handleChange = (e) => {
        //console.log('handle change', e.target.name, e.target.value);
        if (["neverOrder"].includes(e.target.name) || ["noReturn"].includes(e.target.name)) {
            this.setState({
                [e.target.name]: e.target.checked
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    // handle clearing out the datepicker
    handleClearDate = fieldName => {

        this.setState({
            [fieldName]: null
        });
        //this.forceUpdate();
    }

    //<input
    //type="checkbox"
    //id="partExceptionCheckbox"
    //readOnly
    //checked={this.state.neverOrder} />
    //<label className="checkbox" name="neverOrder" onClick={this.handleChange} />
    //<label className="label" htmlFor="part-exception-never-order" >Never order this item again</label>
    //<ToolbarOption onEditScrtooltip={true} type="close" handleClick={this.props.handleCloseModal} />
    //<input type="checkbox" id="part-exception-never-order" name="neverOrder" checked={this.state.neverOrder} className="apple-switch" onChange={this.handleChange} />
    //<label className="apple-switch-label" htmlFor="part-exception-never-order">Never order this item again</label>
    render() {
        //let top = window.visualViewport.pageTop + (window.innerHeight - 200) / 2;
        let top = window.pageYOffset + (window.innerHeight - 200) / 2;

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0134@ Unable to retrieve part exception of %var1%. Please try again. !DEVNOTE! Error dialog
        //!DBTRANS! @m0135@ You must select an adjustment reason. !DEVNOTE! Action status reason
        //!DBTRANS! @m0136@ Minimum stocking qty cannot be greater than maximum stocking qty. !DEVNOTE! Action status reason
        //!DBTRANS! @m0137@ You must select a season if you set in-season minimum qty. !DEVNOTE! Action status reason
        //!DBTRANS! @m0138@ set !DEVNOTE! Action status
        //!DBTRANS! @m0139@ deleted !DEVNOTE! Action status
        //!DBTRANS! @m0140@ The exception was %action%! !DEVNOTE! Action status
        //!DBTRANS! @m0141@ The exception could not be %action%. !DEVNOTE! Action status
        //!DBTRANS! @m0142@ Exception settings !DEVNOTE! Setting labels
        //!DBTRANS! @m0143@ Part Number:%space%  !DEVNOTE! Field label
        //!DBTRANS! @m0144@  Vendor: %space% !DEVNOTE! Field label
        //!DBTRANS! @m0145@ Changes to these settings will affect future suggested orders, but not the current one. !DEVNOTE! Text description
        //!DBTRANS! @m0146@ Minimum stocking qty !DEVNOTE! Text label
        //!DBTRANS! @m0147@ Min expiry date !DEVNOTE! Text label
        //!DBTRANS! @m0148@ Maximum stocking qty !DEVNOTE! Text label
        //!DBTRANS! @m0149@ Max expiry date !DEVNOTE! Text label
        //!DBTRANS! @m0150@ Season !DEVNOTE! Text label
        //!DBTRANS! @m0151@ In-season minimum qty !DEVNOTE! Text label
        //!DBTRANS! @m0152@ Never order this item again !DEVNOTE! Field label
        //!DBTRANS! @m0153@ Adjustment reason !DEVNOTE! Field label
        //!DBTRANS! @m0154@ Warning !DEVNOTE! Text label
        //!DBTRANS! @m0155@ This part %var1% is marked as Never Order, all other settings will be cleared. !DEVNOTE! Setting warning
        //!DBTRANS! @m0156@ Are you sure you want to continue? !DEVNOTE! Option label
        //!DBTRANS! @m0574@ No !DEVNOTE! Option label
        //!DBTRANS! @m0575@ No Return !DEVNOTE! Option label

        return (
            <div className="position-relative">
                <div className="k-window-title k-dialog-title exception-settings">{this.props.returnLocalizedString("m0142")}</div>
                <div className="grid">
                    <div className="grid-row">
                        <div className="grid-col m-col-12 d-col-12">
                            <div className="k-dialog-title2">{this.props.returnLocalizedString("m0143")}<span>{this.state.partNumber}</span>{this.props.returnLocalizedString("m0144")}<span>{this.state.vendorCode}</span></div>
                            <div className="k-dialog-warning">
                                {this.props.returnLocalizedString("m0145")}
                            </div>
                            <FormSection>
                                <div>
                                    <span className="k-form-field right-margin-20">
                                        <NumericTextBox name="stockingMIN" label= {this.props.returnLocalizedString("m0146")} spinners={false} value={this.state.stockingMIN} onChange={this.handleChange} />
                                    </span>
                                    <span className="k-form-field">
                                        <DatePickerContainer
                                            id="minExpiryDate"
                                            value={this.state.minExpiryDate}
                                            label={this.props.returnLocalizedString("m0147")}
                                            showLabel={true}
                                            name="minExpiryDate"
                                            onChange={this.handleChange}
                                            handleClearDate={this.handleClearDate}
                                        />
                                    </span>
                                </div>
                                <div>
                                    <span className="k-form-field right-margin-20">
                                        <NumericTextBox name="stockingMAX" label={this.props.returnLocalizedString("m0148")} spinners={false} value={this.state.stockingMAX} onChange={this.handleChange} />
                                    </span>
                                    <span className="k-form-field">
                                        <DatePickerContainer
                                            id="maxExpiryDate"
                                            value={this.state.maxExpiryDate}
                                            label={this.props.returnLocalizedString("m0149")}
                                            showLabel={true}
                                            name="maxExpiryDate"
                                            onChange={this.handleChange}
                                            handleClearDate={this.handleClearDate}
                                        />
                                    </span>
                                </div>
                                <div className="top-margin-10">
                                    <span className="k-form-field right-margin-20 drop-down-field">
                                        <DropDownList
                                            value={this.state.season}
                                            name="season"
                                            label={this.props.returnLocalizedString("m0150")}
                                            data={this.state.seasons}
                                            textField="seasonName"
                                            dataItemKey="seasonID"
                                            onChange={this.handleChange}
                                        />
                                    </span>
                                    <span className="k-form-field right-field">
                                        <NumericTextBox name="seasonMin" label={this.props.returnLocalizedString("m0151")} spinners={false} value={this.state.seasonMin} onChange={this.handleChange} />
                                    </span>
                                </div>
                                <div className="boolean" >
                                    <input type="checkbox" id="part-exception-never-order" name="neverOrder" checked={this.state.neverOrder} className="k-checkbox" onChange={this.handleChange} />
                                    <label className="k-checkbox-label" htmlFor="part-exception-never-order">{this.props.returnLocalizedString("m0152")}</label>
                                </div>
                                <div className="boolean" >
                                    <input type="checkbox" id="part-exception-no-return" name="noReturn" checked={this.state.noReturn} className="k-checkbox" onChange={this.handleChange} />
                                    <label className="k-checkbox-label" htmlFor="part-exception-no-return">{this.props.returnLocalizedString("m0575")}</label>
                                </div>
                                <div className="dropdown" >
                                    <DropDownList
                                        value={this.state.adjReason}
                                        name="adjReason"
                                        label={this.props.returnLocalizedString("m0153")}
                                        disabled={!this.state.neverOrder}
                                        data={this.state.adjustmentReasons}
                                        textField="adjustmentReason"
                                        dataItemKey="adjustmentReasonID"
                                        onChange={this.handleChange}
                                    />
                                </div>
                                {this.state.showConfirmationDialog && (
                                    <Dialog className="confirmation"
                                        width={500}
                                        style={{ height: 'auto', top: top, margin: '0 auto' }}
                                        closeIcon={false}
                                        title= {this.props.returnLocalizedString("m0154")}
                                        onClose={this.handleCloseConfirmationDialog}>

                                            {this.props.returnLocalizedString("m0155", "", this.state.partNumber)}
                                        <br />
                                        {this.props.returnLocalizedString("m0156")}
                                        <DialogActionsBar>
                                            <Button className="cancel" onClick={(e) => {
                                                this.handleCloseConfirmationDialog();
                                            }}>{this.props.returnLocalizedString("m0574")}</Button>
                                            <Button className="yes" primary={true} onClick={(e) => {
                                                this.handleSubmit(e, true);
                                                this.handleCloseConfirmationDialog();
                                            }}>{this.props.returnLocalizedString("m0176")}</Button>
                                        </DialogActionsBar>
                                    </Dialog>)
                                }
                            </FormSection>
                            <Toolbar onEditScrtooltip={false} atBottom={true} >
                                <ToolbarOption onEditScrtooltip={false} type="cancel" handleClick={this.props.handleCloseModal} />
                                <ToolbarOption onEditScrtooltip={false} type="save" primary={true} handleClick={this.handleSubmit} />
                            </Toolbar>
                        </div>
                    </div>
                </div>
                <Toolbar forPartException={true} >
                    <ToolbarOption onEditScrtooltip={false} type="clear" handleClick={this.handleClearData} />
                </Toolbar>
            </div>
        )
    }
}
export default isPage(EditPartExceptionPage);



// WEBPACK FOOTER //
// ./src/containers/EditPartExceptionPage.js